import React, { useEffect,useState } from "react";
import Skills from "../../containers/skills/Skills";
import Footer from "../../components/footer/Footer";
import TopButton from "../../components/topButton/TopButton";
import Carousel from "../../containers/Carousel/Carousel.jsx";
import Navigationbar from "../../components/header/Navigationbar.jsx";
import About from "../../components/About/About.js";
import OurServices from "../../components/OurService/OurServices.js";
import Faq from "../../components/FAQ/Faq.js";
import "./home.css";
import TestimonialSlider from "../../components/Testimonials/TestimonialSlider.js";
import ChartsTrading from "../../components/Charts/ChartsTrading.js";
import Stock from "../../components/Charts/Stock.jsx";
import TradingTable from "../../components/Charts/TradingTable.jsx";
import TechnicalAnalysis from "../../components/Charts/TechnicalAnalysis.jsx";
import Timeline from "../../components/Charts/Timeline.jsx";
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import WhatsAppCard from "../../../src/pages/contact/WhatsAppCard.jsx";


const Home = (props) => {
  const [darkMode, setDarkMode] = useState(false);
  const handleModeToggle = () => {
    setDarkMode(!darkMode);
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  
  useEffect(() => {
    if (document.getElementById('tradingview-widget-script')) {
      return;
    }
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src =
      'https://s3.tradingview.com/external-embedding/embed-widget-ticker-tape.js';
    script.async = true;
    script.id = 'tradingview-widget-script';

    script.innerHTML = JSON.stringify({
        "symbols": [
          {
            "proName": "FOREXCOM:SPXUSD",
            "title": "S&P 500"
          },
          {
            "description": "sensex",
            "proName": "BSE:SENSEX"
          },
          {
            "proName": "FOREXCOM:NSXUSD",
            "title": "US 100"
          },
          {
            "proName": "FX_IDC:EURUSD",
            "title": "EUR to USD"
          },
          {
            "proName": "BITSTAMP:BTCUSD",
            "title": "Bitcoin"
          },
          {
            "proName": "BITSTAMP:ETHUSD",
            "title": "Ethereum"
          },
          {
            "description": "usoil",
            "proName": "TVC:USOIL"
          },
          {
            "description": "gold",
            "proName": "TVC:GOLD"
          }
        ],
        showSymbolLogo: true,
        isTransparent: false,
        displayMode: 'adaptive',
        colorTheme: 'light',
        locale: 'in',
      });
      const widgetContainer = document.querySelector(
        '.tradingview-widget-container__widget'
      );
      if (widgetContainer) {
        widgetContainer.appendChild(script);
      }
      return () => {
        if (script && script.parentNode === widgetContainer) {
          widgetContainer.removeChild(script);
        }
      };
    }, []);
    
  return (
    <>
      <Navigationbar />
      <Carousel />
      <div className="tradingview-widget-container">
        <div className="tradingview-widget-container-main">
          <div className="column">
            <span className="blue-text">World Top Market:</span>
          </div>
          <div className="tradingview-widget-container">
            <div className="tradingview-widget-container__widget"></div>
          </div>
        </div>
      </div>
      <br />
        <div>
          <Stock />
        </div>
        <div className='trading-main'>
          <div className='charttrading'>
            <ChartsTrading />
          </div>
          <div className='tradingtable'>
            <TradingTable darkMode={darkMode}/>
          </div>
        </div>
        <br />
        <div className='trading-main-new'>
          <div className='technicalanalysis'>
            <TechnicalAnalysis />
          </div>
          <div className='timeline'>
            <Timeline />
          </div>
        </div>
      <br/>
      <About />
      <OurServices />
      <Skills theme={props.theme} />
      <Faq />
      <TestimonialSlider />
      <Footer theme={props.theme} />
      <TopButton theme={props.theme} />
      <WhatsAppCard/>
    </>
  );
};

export default Home;
